import { api } from "../utils/AuthManager";
const GetAllPricelists = async () => {
  return api
    .get(`/api/pricelist/`)

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetAllPricelists;
